import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, styled } from "@material-ui/core";
import React from "react";

interface IPropsCancelSubscription {
    title: string;
    dialogContent: JSX.Element;
    actionDialog: JSX.Element;
    isOpen: boolean;
    onClose: () => void;
}

const CancelSubscription = (props: IPropsCancelSubscription) => {
    return (<DialogCancelSubscription
        open={props.isOpen}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
            style: {
                background: "#0B0B0B",
                border: "1px solid #35383F",
                padding: 24,
                borderRadius: 10,
                width: "calc(375px + 32px + 32px)",
                boxSizing: "border-box",
            }
        }}
    >
        <DialogTitle>
            {props.title}
        </DialogTitle>
        {props.dialogContent}
        <DialogActions>
            <Button className="dialogBtn noBtn" onClick={() => props.onClose()}>No</Button>
            {props.actionDialog}
        </DialogActions>

    </DialogCancelSubscription>)
}

const DialogCancelSubscription = styled(Dialog)(() => ({
    "& .MuiDialogTitle-root": {
        borderBottom: "1px solid #222222",
        textAlign: "center",
        height: 53,
        padding: 0,
        "& h2": {
            fontSize: 18,
            fontFamily: "Manrope",
            fontWeight: 800,
            color: "#FFF"
        }
    },
    "& .MuiDialogContent-root": {
        padding: "17px 0 25px",
        textAlign: "center",
        "& .MuiDialogContentText-root": {
            fontWeight: 600,
            fontFamily: "Manrope",
            fontSize: 16,
            color: "#FFF",
            margin: 0,
        }
    },
    "& .MuiDialogActions-root": {
        padding: 0,
        justifyContent: "space-between",
        gap: 12,
        "& .dialogBtn": {
            flex: 1,
            padding: 16,
            border: "1px solid #FFF",
            borderRadius: 10,
            cursorL: "pointer",
            "& .MuiButton-label": {
                textTransform: "capitalize",
                fontFamily: "Manrope",
                fontWeight: 700,
                fontSize: 14,
                color: "#FFF",
            }
        },
        "& .dialogBtn.cancelSubscriptionBtn": {
            border: "1px solid #DC2626",
            "& .MuiButton-label": {
                color: "#DC2626",
            }
        },
    }
}))

export default CancelSubscription;